import { render } from "./orderRequestHistory.vue?vue&type=template&id=1cdd3d8e"
import script from "./orderRequestHistory.vue?vue&type=script&lang=js"
export * from "./orderRequestHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__